if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;

      this.isSubmitting = false;
      
      const idInput = this.form.querySelector('[name=id]');
      if (idInput) idInput.disabled = false;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      // Guard against rapid double-clicks
      if (this.isSubmitting) return;
      if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.isSubmitting = true;
      this.handleErrorMessage();

      if (this.cartNotification) {
        this.cartNotification.setActiveElement(document.activeElement);
      }

      if (this.submitButton) {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
      }

      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      // --- FIX: Prevent duplicate inputs (e.g., 2 quantity fields in HTML) ---
      if (formData.has('quantity')) {
        const quantities = formData.getAll('quantity');
        if (quantities.length > 1) {
          formData.delete('quantity');
          formData.append('quantity', quantities[0]); // Keep only the first valid quantity
        }
      }

      if (this.cartNotification) {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      }
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span')?.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;

          window.dispatchEvent(new CustomEvent('cart:refresh_drawer'));
          window.dispatchEvent(new CustomEvent('cart:open'));

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { 
                if (this.cartNotification) this.cartNotification.renderContents(response); 
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else if (this.cartNotification) {
            this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.submitButton) {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          }
          this.isSubmitting = false;
          if (spinner) spinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
